// extracted by mini-css-extract-plugin
export default {"link-view":"ViewLinkButton_link-view__c3X2Q","link-view-text":"ViewLinkButton_link-view-text__2b6Am","truncate":"ViewLinkButton_truncate__8HLxa"};